import {Form, Select} from 'antd';
import {Rule} from 'antd/es/form';

import {CompanyMultiSelectV2} from '../../../layout/company-multi-select-v2/company-multi-select-v2';
import {SelectCatalogOption} from '../../../layout/select/select-catalog-option';
import {CatalogRulesType} from '../../../provider/catalogs/catalogs-type';
import {Locale} from '../../../provider/locale/locale';
import {LangKeyType} from '../../../provider/locale/translation/type';
import {UseCompaniesSelectorHookType} from '../../../service/feature-companies/feature-companies-type';

import * as styles from './auto-reply-form.scss';

type PropsType = {
    catalogsHookResult: Array<CatalogRulesType>;
    catalogsIsInProgress: boolean;
    companiesSelector: UseCompaniesSelectorHookType;
    companiesSelectorGpt: UseCompaniesSelectorHookType;
    getCompaniesMultiselectValidationRule: (selectedCount: number) => Rule;
    getLocalizedString: (stringKey: LangKeyType) => string;
    isShowTemplateBlock: boolean;
    selectedCount: number;
    selectedCountGpt: number;
};

export function AutoReplyFormFiltersCompany(props: PropsType): JSX.Element {
    const {
        catalogsHookResult,
        catalogsIsInProgress,
        companiesSelector,
        companiesSelectorGpt,
        getCompaniesMultiselectValidationRule,
        getLocalizedString,
        isShowTemplateBlock,
        selectedCount,
        selectedCountGpt,
    } = props;

    return (
        <>
            <Form.Item
                label={
                    <div className={styles.AutoReplyForm_requiredAsterisk}>
                        <Locale stringKey="AUTO_REPLIES__FORM__COMPANIES" />
                    </div>
                }
                name="companies"
                rules={[getCompaniesMultiselectValidationRule(isShowTemplateBlock ? selectedCount : selectedCountGpt)]}
                validateFirst={false}
                validateTrigger="onSubmit"
            >
                <CompanyMultiSelectV2
                    companiesSelector={isShowTemplateBlock ? companiesSelector : companiesSelectorGpt}
                    isDisabled={false}
                />
            </Form.Item>

            <Form.Item
                label={<Locale stringKey="AUTO_REPLIES__FORM__FEEDBACK_SOURCE" />}
                name="catalogs"
                rules={[{required: true, message: getLocalizedString('VALIDATION__ERROR__FIELD_IS_REQUIRED')}]}
            >
                <Select<number>
                    loading={catalogsIsInProgress}
                    mode="multiple"
                    placeholder={getLocalizedString('AUTO_REPLIES__FORM__SELECT_SOURCES')}
                    showSearch={false}
                    size="large"
                >
                    {catalogsHookResult.map(SelectCatalogOption)}
                </Select>
            </Form.Item>
        </>
    );
}
